import { Button } from 'blaze-ui/Button'
import { useImagePickerContext } from './ImagePickerContext'

export const DeselectAllButton = () => {
  const { setSelectedImages, isUploading } = useImagePickerContext()
  return (
    <Button variant="tertiary" onPress={() => setSelectedImages([])} isDisabled={isUploading}>
      Deselect All
    </Button>
  )
}
